import { formatLocation } from "kinnect-formatters";
import {
	Customer,
	Model,
	YardSchedule
} from ".";

export default class Address extends Model {
	get singularNoun() {
		return "address";
	}

	get pluralNoun() {
		return "addresses";
	}

	get mutations() {
		return {
			customer: Customer,
			schedules: YardSchedule
		};
	}

	get fullAddress() {
		return formatLocation( this );
	}
}
